import React, { Component } from 'react';

class LoginErrorModal extends Component{

    componentDidMount(){
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) =>{
        let modal = document.getElementById('loginErrorModalWindow');

        if(this.props.showModalWindow && e.target.id !== modal.id && !modal.contains(e.target)){
           this.props.closeModal();
        }
    }

    render(){
        const backdropStyle = {
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(0,0,0,0.3)',
            padding: 50
        };

        const modalStyle = {
            backgroundColor: '#fff',
            borderRadius: 5,
            maxWidth: 400,
            minHeight: 150,
            margin: '0 auto',
            marginTop: '125px',
            padding: 0
        };

        const titleStyle = {
            backgroundColor: '#ff4d4d',
            width: '100%',
            color: 'white',
            fontWeight: 'bold',
            paddingLeft: 20,
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5
        };

        const contents = {
          padding: 20,
          fontFamily: 'Rubik'
        };

        const closeButton = {
          display: 'block',
          float: 'right',
          border: 'none',
          marginRight: 30,
          width: 100,
          cursor: 'pointer'
        };

        if(!this.props.showModalWindow){
            return null;
        }

        return (
            <div style={backdropStyle}>
                <div id="loginErrorModalWindow" style={modalStyle}>
                    <div>
                        <div style={titleStyle}>
                            <span>Invalid Page</span>
                        </div>
                        <div style={contents}>
                            <span>Sorry you've tried to reach an invalid page. Please login to continue.</span>
                        </div>
                        <div>
                            <button style={closeButton} onClick={() => this.props.closeModal()}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default LoginErrorModal;


// WEBPACK FOOTER //
// ./src/LoginErrorModal.js